import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-toggle-logo" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center",
  style: {"align-self":"stretch"}
}
const _hoisted_3 = {
  key: 1,
  class: "q-mx-md xs-hide sm-hide md-hide",
  style: {"flex-grow":"3"}
}
const _hoisted_4 = { class: "q-gutter-sm row items-center no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_active_account = _resolveComponent("active-account")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_select_search_user_client = _resolveComponent("select-search-user-client")!
  const _component_social_accounts_status = _resolveComponent("social-accounts-status")!
  const _component_resources_dropdown = _resolveComponent("resources-dropdown")!
  const _component_support_btn = _resolveComponent("support-btn")!
  const _component_user_dropdown = _resolveComponent("user-dropdown")!
  const _component_user_notifications_btn = _resolveComponent("user-notifications-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    bordered: "",
    class: "bg-white text-grey-8",
    "height-hint": "58"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.isGranted('VIEW_CLIENTS'))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  icon: "fa fa-bars",
                  "aria-label": "Menu",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
                  flat: "",
                  dense: "",
                  round: ""
                }))
              : _createCommentVNode("", true),
            (_ctx.$q.screen.gt.sm)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  flat: "",
                  "no-caps": "",
                  "no-wrap": "",
                  class: "q-ml-xs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_toolbar_title, { shrink: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {name: 'dashboard'},
                          class: "q-link text-weight-bold text-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Private Footprint ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isGranted('VIEW_ACTIVE_ACCOUNT'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_active_account, {
                  modelValue: _ctx.account,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.account) = $event)),
                  class: "full-height"
                }, null, 8, ["modelValue"]),
                (_ctx.account)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      icon: "fa fa-cog",
                      to: `/admin/accounts/${_ctx.accountId}/users`,
                      title: "Admin",
                      flat: "",
                      stretch: ""
                    }, null, 8, ["to"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_separator, {
                  vertical: "",
                  inset: "",
                  class: "on-left"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_navigation),
          _createVNode(_component_q_space),
          (_ctx.isCustomer && _ctx.isGranted('VIEW_CLIENTS'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_select_search_user_client, { onChange: _ctx.selectClient }, null, 8, ["onChange"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_space),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isGranted('VIEW_CLIENTS') && _ctx.accountId)
              ? (_openBlock(), _createBlock(_component_social_accounts_status, {
                  key: 0,
                  "account-id": _ctx.accountId
                }, null, 8, ["account-id"]))
              : _createCommentVNode("", true),
            (_ctx.isGranted('VIEW_RESOURCES'))
              ? (_openBlock(), _createBlock(_component_resources_dropdown, { key: 1 }))
              : _createCommentVNode("", true),
            _createVNode(_component_support_btn, {
              flat: "",
              rounded: ""
            }),
            _createVNode(_component_user_dropdown),
            _createVNode(_component_user_notifications_btn)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}